import { GrayBox } from "../../../../ui-components/GrayBox";
import { SeparatorHorizontal } from "../../../../ui-components/SeparatorHorizontal/SeparatorHorizontal";

export const MoreAboutBox = ({
  children,
  title,
  className,
}: { children: React.ReactNode; title: string; className?: string }) => {
  return (
    <GrayBox className={`flex flex-col gap-4 ${className}`}>
      <h3 className="text-lg font-semibold">{title}</h3>
      <SeparatorHorizontal />
      {children}
    </GrayBox>
  );
};
